// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"46":"SapiMagicSortOverlay","230":"confirmation","764":"payment","923":"roomselection"}[chunkId] || chunkId) + "." + {"46":"465032ca","56":"f4d4734a","230":"8ad6e36b","456":"f4d4734a","764":"1ac709b4","923":"01bd2761"}[chunkId] + ".chunk.css";
};